/**
 * @module Components
 *
 */
import React from "react";
import TermsOfService from "app/components/links/TermsOfService";
import PrivacyPolicy from "app/components/links/PrivacyPolicy";
import Support from "app/components/links/Support";
import Contact from "app/components/links/Contact";
import styles from "../styles.module.scss";
import config from "config/environment";
import { useTranslation } from "react-i18next";

export default function LoggedOutFooter() {
  const { t } = useTranslation();
  return (
    <div className={styles.footer}>
      <span>
        <TermsOfService />
      </span>
      <span>
        <PrivacyPolicy />
      </span>
      <span>
        <Support />
      </span>
      <span>
        <Contact />
      </span>
      <span>
        &copy;
        {t("{{year}} CoachNow", { year: config.CURRENT_YEAR })}
      </span>
    </div>
  );
}
